/* eslint-disable ember/no-mixins */
import EmberObject, { computed } from "@ember/object";
import { translationOrText } from "discourse/plugins/discourse-custom-wizard/discourse/lib/wizard";
import ValidState from "discourse/plugins/discourse-custom-wizard/discourse/mixins/valid-state";

const StandardFieldValidation = [
  "text",
  "number",
  "textarea",
  "dropdown",
  "tag",
  "image",
  "user_selector",
  "text_only",
  "composer",
  "category",
  "topic",
  "group",
  "date",
  "time",
  "date_time",
];

export default class CustomWizardField extends EmberObject.extend(ValidState) {
  id = null;
  type = null;
  value = null;
  required = null;

  @computed("wizardId", "stepId", "id")
  get i18nKey() {
    return `${this.wizardId}.${this.stepId}.${this.id}`;
  }

  @computed("i18nKey", "label")
  get translatedLabel() {
    return translationOrText(`${this.i18nKey}.label`, this.label);
  }

  @computed("i18nKey", "placeholder")
  get translatedPlaceholder() {
    return translationOrText(`${this.i18nKey}.placeholder`, this.placeholder);
  }

  @computed("i18nKey", "description")
  get translatedDescription() {
    return translationOrText(`${this.i18nKey}.description`, this.description);
  }

  check() {
    if (this.customCheck) {
      return this.customCheck();
    }

    let valid = this.valid;

    if (!this.required) {
      this.setValid(true);
      return true;
    }

    const val = this.get("value");
    const type = this.get("type");

    if (type === "checkbox") {
      valid = val;
    } else if (type === "upload") {
      valid = val && val.id > 0;
    } else if (StandardFieldValidation.indexOf(type) > -1) {
      valid = val && val.toString().length > 0;
    } else if (type === "url") {
      valid = true;
    }

    this.setValid(Boolean(valid));

    return valid;
  }
}
